import styled from "styled-components"
import { TableRow } from "@material-ui/core"

export const THeadRow = styled(TableRow)`
  color: var(--text-color-second);
`
